import { createRouter, createWebHashHistory } from 'vue-router'
import { isLoggedIn, isSuperAdmin } from '../utils/auth'

const HIDDEN_LOGIN_PATH = '/portal-audit-7Kx92LmQp4Nz8Ta1VbC6RwYd'

const routes = [
  {
    path: '/',
    name: 'home-landing',
    component: () => import('../views/public/HomeLandingPage.vue'),
    meta: { public: true }
  },
  {
    path: HIDDEN_LOGIN_PATH,
    name: 'hidden-login',
    component: () => import('../views/LoginView.vue'),
    props: { allowRegister: false },
    meta: { guest: true }
  },
  {
    path: '/admin',
    component: () => import('../layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    redirect: '/admin/accounts',
    children: [
      {
        path: 'users',
        name: 'users',
        component: () => import('../views/users/UserList.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'users/new',
        name: 'user-new',
        component: () => import('../views/users/UserEdit.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'users/:id/edit',
        name: 'user-edit',
        component: () => import('../views/users/UserEdit.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'backup',
        name: 'backup-manager',
        component: () => import('../views/system/BackupManager.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'recycle-bin',
        name: 'recycle-bin-manager',
        component: () => import('../views/system/RecycleBinManager.vue'),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'endpoints',
        name: 'endpoints',
        component: () => import('../views/endpoints/EndpointList.vue')
      },
      {
        path: 'accounts',
        name: 'accounts',
        component: () => import('../views/accounts/AccountList.vue')
      },
      {
        path: 'accounts/:id/edit',
        name: 'account-edit',
        component: () => import('../views/accounts/AccountEdit.vue')
      },
      {
        path: 'square-accounts',
        name: 'square-accounts',
        component: () => import('../views/accounts/SquareAccountList.vue')
      },
      {
        path: 'square-accounts/:id/edit',
        name: 'square-account-edit',
        component: () => import('../views/accounts/SquareAccountEdit.vue')
      },
      {
        path: 'scan-import-accounts',
        name: 'scan-import-accounts',
        component: () => import('../views/accounts/ScanImportAccountList.vue')
      },
      {
        path: 'packages',
        name: 'packages',
        component: () => import('../views/packages/PackageList.vue')
      },
      {
        path: 'packages/:id/edit',
        name: 'package-edit',
        component: () => import('../views/packages/PackageEdit.vue')
      },
      {
        path: 'packages/new',
        name: 'package-new',
        component: () => import('../views/packages/PackageEdit.vue')
      },
      {
        path: 'cards',
        name: 'cards',
        component: () => import('../views/cards/CardList.vue')
      },
      {
        path: 'scan-accounts',
        name: 'scan-accounts',
        component: () => import('../views/scanAccounts/ScanAccountList.vue')
      }
    ]
  },
  {
    path: '/c/:code',
    name: 'card-public',
    component: () => import('../views/public/CardPage.vue'),
    meta: { public: true }
  },
  {
    path: '/scan/:code',
    name: 'scan-public',
    component: () => import('../views/public/ScanAccountPage.vue'),
    meta: { public: true }
  },
  {
    path: '/view/:key',
    name: 'endpoint-monitor',
    component: () => import('../views/public/EndpointMonitor.vue'),
    meta: { public: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.meta.public || to.meta.guest) return true
  if (to.meta.requiresAuth && !isLoggedIn()) {
    return { name: 'hidden-login', query: { redirect: to.fullPath } }
  }
  if (to.meta.requiresSuperAdmin && !isSuperAdmin()) {
    return { path: '/admin/accounts' }
  }
  if (to.name === 'hidden-login' && isLoggedIn()) {
    return { path: '/admin/accounts' }
  }
  return true
})

export default router
